import React, { Suspense } from 'react'
import { compose } from 'redux'
import asWindow from 'HigherOrder/asWindow.jsx'

// Summit has been using react-code-splitting library in Async.jsx but that was
// deprecated by the author in favor of React.lazy.  This mechanism solves
// some issues with error loops if a component errors on load (I believe in
// part due to STORE_WAITLIST_STREAM being dispatched repeatedly).  It also
// shows a loading state Window of the correct title, size, color, etc while
// the real Window code lazy-loads from the server.

// Note: Summit internal framework errors if class components are not returned
// by these HOCs

const Async = WrappedComponent => {
  return class extends React.Component {
    render() {
      return (
        <Suspense fallback={<div />}>
          <WrappedComponent {...this.props} />
        </Suspense>
      )
    }
  }
}
export default Async
